// extracted by mini-css-extract-plugin
export default {"error":"FormTextArea_error__cix2k","textarea":"FormTextArea_textarea__p1bGl"};